<div class="wetter_content_container">
  <div class="bericht-text-container">
    <h3>Headline</h3>
    {{langWetterbericht?.headline}}
  </div>
  <div class="bericht-text-container">
    <h3>{{langWetterbericht?.caption_wx_condition}}</h3>
    {{langWetterbericht?.wx_condition}}
  </div>
  <div class="bericht-text-container">
    <h3>{{langWetterbericht?.caption_wx_text_1}}</h3>
    {{langWetterbericht?.wx_text_1}}
  </div>
  <div class="bericht-text-container">
    <h3>{{langWetterbericht?.caption_wx_text_2}}</h3>
    {{langWetterbericht?.wx_text_2}}
  </div>
  <div class="bericht-text-container">
    <h3>{{langWetterbericht?.caption_wx_next_days}}</h3>
    {{langWetterbericht?.wx_next_days}}
  </div>
  <div class="bericht-text-container">
    <h3>{{langWetterbericht?.caption_wx_trend}}</h3>
    {{langWetterbericht?.wx_trend}}
  </div>
  <div class="bericht-text-container">
    <h3>{{langWetterbericht?.caption_wx_mountains}}</h3>
    {{langWetterbericht?.wx_mountains}}
  </div>
  <div class="bericht-text-container">
    {{langWetterbericht?.footer}}
  </div>
</div>
